export default "__VITE_ASSET__D3FfN8Gw__"